import { nowUtc } from '@/lib/clock';
import type { GentleTaskDatabase } from '@/data/db/database';
import { SETTINGS_ID } from '@/data/db/settings.schema';
import type { UtcTimestamp } from '@/data/db/primitives';

/** 新建資料的稽核欄位。 */
export function newAudit(timestamp: UtcTimestamp = nowUtc()) {
  return { createdAt: timestamp, updatedAt: timestamp, revision: 1 };
}

/** 既有資料被修改時的稽核欄位；revision 只在本機遞增，供多分頁衝突偵測使用。 */
export function bumpAudit(
  current: { revision: number },
  timestamp: UtcTimestamp = nowUtc(),
): { updatedAt: UtcTimestamp; revision: number } {
  return { updatedAt: timestamp, revision: current.revision + 1 };
}

/**
 * 記錄最後一次資料異動，供「資料異動後七天仍未匯出」的備份提醒使用
 * （data-model 8.1）。必須在呼叫端的交易內執行。
 */
export async function markDataMutation(
  db: GentleTaskDatabase,
  timestamp: UtcTimestamp = nowUtc(),
): Promise<void> {
  await db.settings.update(SETTINGS_ID, { lastDataMutationAt: timestamp });
}

export class NotFoundError extends Error {
  constructor(what: string, id: string) {
    super(`找不到${what}：${id}`);
    this.name = 'NotFoundError';
  }
}
